

import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

export default function Confirmdialog(props) {
    const { open, description, Agreetxt, Disagreetxt, title } = props

    const handleClose = (e) => {
        props.data(e)
        props.closedialog(false);
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {typeof title === "undefined" || title === "" ? 'แจ้งเตือน' : title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {description}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={_ => handleClose("Y")}>{Agreetxt === "" ? 'ตกลง' : Agreetxt}</Button>
                    <Button onClick={_ => handleClose("N")}>{typeof Disagreetxt === "undefined" || Disagreetxt === "" ? 'ยกเลิก' : Disagreetxt}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}



Confirmdialog.propTypes = {
    open: PropTypes.bool,
    description: PropTypes.string,
    Agreetxt: PropTypes.string,
    Disagreetxt: PropTypes.string,
    title: PropTypes.string
} 